<template>
  <div>
    <!-- 导航栏 -->
    <!-- <nav-header :href="this.href"></nav-header> -->

    <div class="container">
      <!-- 纠纷处理 -->
      <div class="ag-con">
        <h3>交易纠纷处理</h3>
        <div class="t-con">
          <p>
            北京爱评乐玩网络技术有限公司
            （以下简称爱评乐玩）在此特别提醒用户在注册、登录本站前请务必仔细阅读本《纠纷处理方式》（未成年人应当在其法定监护人陪同下阅读）中的各个条款，以确保您在享受本站服务的同时维护自身合法权益：
          </p>
        </div>

        <h3>1.用户之间纠纷处理方式</h3>
        <div class="t-con">
          <p>
            （1）爱评乐玩仅作为本站的运营商，如若本站用户之间发生纠纷且无法协商一致的，可向国家相关行政机关或司法机关寻求解决包括但不限于向公安机关报案、申请仲裁或向人民法院提起诉讼等。爱评乐玩将会为实名注册用户提供必要的协助和支持，并根据有关行政机关和司法机关的要求承担一定的举证责任或采取必要措施。
          </p>
        </div>

        <h3></h3>
        <div class="t-con">
          <p>
            （2）本站用户之间发生纠纷的，也可向爱评乐玩客服人员投诉并举证。用户需提供与其账号注册信息一致的个人有效身份证件、必要的国家行政或司法机关文件和其他爱评乐玩要求提供的相关证据。经爱评乐玩审核确认后，可以给予必要的协助和支持。
          </p>
        </div>

        <h3>用户与爱评乐玩之间纠纷处理方式</h3>
        <div class="t-con">
          <p>
            （1）如本站用户对爱评乐玩的服务有任何异议的，可以向爱评乐玩的客服人员投诉并举证。查证属实的，爱评乐玩将立即更正并按照现行法律规定给予用户必要的补偿。
          </p>
        </div>

        <h3></h3>
        <div class="t-con">
          <p>
            （2）如本网站用户对爱评乐玩的服务有任何异议的，也可以向双方约定的爱评乐玩公司所在地人民法院提起诉讼。
            抵制不良音乐 拒绝盗版音乐 注意自我保护 谨防受骗上当 适度音乐益脑
            沉迷音乐伤身 合理安排时间 享受健康生活
          </p>
        </div>

        <h3></h3>
        <div class="t-con">
          <p></p>
        </div>

        <!-- <h4>纠纷处理人：李登科</h4>
        <h4>电话：18632664257</h4>

        <h4>地址：北京市朝阳区豆各庄黄厂西路1号A1栋二层22570</h4> -->
      </div>
    </div>
  </div>
</template>

<script>
// import NavHeader from "./../components/NavHeader";
export default {
  name: "ag",
  components: {
    // NavHeader,
  },
  data() {
    return {
      href: "index.html",
    };
  },
  methods() {
    document.title = "爱评乐玩";
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.container {
  .ag-con {
    margin: 30px auto;
    // 文字容器
    .t-con {
      margin: 30px auto;
      font-size: 14px;
      line-height: 40px;
      text-align: left;
      p {
        margin: 10px auto;
      }
    }
  }
}
</style>
